"use strict";

// Lazily run a callback the first time an element scrolls near the viewport.
// Used to defer Swiper initialization (and its layout measurements / forced
// reflows) until the slider is actually needed. Falls back to running
// immediately if IntersectionObserver is unavailable.
window.ipslInView = function (el, cb, rootMargin) {
    if (!el || typeof cb !== 'function') return;
    if (!('IntersectionObserver' in window)) { cb(); return; }
    const io = new IntersectionObserver((entries, obs) => {
        entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            obs.disconnect();
            cb();
        });
    }, { rootMargin: rootMargin || '200px 0px' });
    io.observe(el);
};

// Header scroll
(() => {
    const header = document.querySelector('header.header');
    if (!header) return;

    let ticking = false;

    const onScroll = () => {
        ticking = false;
        const threshold = window.innerWidth < 1024 ? 4 : 8; // мобайл / десктоп
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
        header.classList.toggle('scroll', scrollTop > threshold);
    };

    window.addEventListener('scroll', () => {
        if (!ticking) {
            ticking = true;
            requestAnimationFrame(onScroll);
        }
    }, { passive: true });

    onScroll(); // виставити стан одразу (напр. перезавантаження зі скролом)
})();

// Animate Scroll
(() => {
    const header = document.querySelector('header');
    const getHeaderHeight = () => header ? header.offsetHeight : 0;

    document.addEventListener('click', (e) => {
        const link = e.target.closest('a[href^="#"]');
        if (!link) return;

        const id = link.getAttribute('href');
        if (!id || id === '#') return;

        const target = document.querySelector(id);
        if (!target) return;

        e.preventDefault();

        const targetTop =
            target.getBoundingClientRect().top +
            window.pageYOffset -
            getHeaderHeight();

        window.scrollTo({
            top: targetTop,
            behavior: 'smooth'
        });
    });
})();

// Mobile Nav Toggle
(() => {
    const body = document.body;
    const burger = document.querySelector('button.burger');
    const nav = document.querySelector('.header-menu');

    if (!burger || !nav) return;

    burger.addEventListener('click', () => {
        body.classList.toggle('overflow-hidden');
        nav.classList.toggle('active');
        burger.classList.toggle('active');
    });
})();

// Lazy Background Image (data-bg)
(() => {
    const elements = document.querySelectorAll('[data-bg]');
    if (!elements.length) return;

    const setBg = (el) => {
        const url = el.dataset.bg;
        if (!url) return;
        el.style.backgroundImage = `url("${url}")`;
        el.removeAttribute('data-bg');
    };

    if (!('IntersectionObserver' in window)) {
        elements.forEach(setBg);
        return;
    }

    const observer = new IntersectionObserver((entries, obs) => {
        entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            setBg(entry.target);
            obs.unobserve(entry.target);
        });
    }, { rootMargin: '200px' });

    elements.forEach((el) => observer.observe(el));
})();

// Social Share
(() => {
    const socialSpans = document.querySelectorAll('.social-share .social-share-main span');

    if (!socialSpans.length) return;

    const copyToClipboard = async (text) => {
        try {
            await navigator.clipboard.writeText(text);
        } catch (e) {
            const tmp = document.createElement('textarea');
            tmp.value = text;
            tmp.setAttribute('readonly', '');
            tmp.style.position = 'absolute';
            tmp.style.left = '-9999px';
            document.body.appendChild(tmp);
            tmp.select();
            document.execCommand('copy');
            document.body.removeChild(tmp);
        }
    };

    socialSpans.forEach((span) => {
        span.addEventListener('click', async () => {
            // Copy link to clipboard.
            if (span.classList.contains('social-share-link')) {
                const copyUrl = span.dataset.copy;
                if (!copyUrl) return;

                await copyToClipboard(copyUrl);
                span.classList.add('copied');
                setTimeout(() => span.classList.remove('copied'), 1500);
                return;
            }

            // Open a profile / external URL directly (e.g. Instagram).
            if (span.dataset.href) {
                window.open(span.dataset.href, '_blank');
                return;
            }

            // Standard share endpoints.
            const link = span.dataset.link;
            const url = span.dataset.url;

            if (!link || !url) return;

            const fullUrl = 'https://' + link + url;
            window.open(fullUrl, '_blank');
        });
    });
})();

(() => {
    const TARGET_CHARS = ['.', '?', '!'];

    const processHeadings = () => {
        const headings = document.querySelectorAll('h1, h2, .styilize-symbols');

        headings.forEach(heading => {
            // ігноруємо headings з класом no-styilize
            if (heading.classList.contains('no-styilize')) return;

            // захист від повторної обробки
            if (heading.querySelector('.text-yellow')) return;

            const walker = document.createTreeWalker(
                heading,
                NodeFilter.SHOW_TEXT,
                {
                    acceptNode(node) {
                        // ігноруємо текст усередині дочірніх елементів з класом no-styilize
                        for (let el = node.parentElement; el && el !== heading; el = el.parentElement) {
                            if (el.classList.contains('no-styilize')) {
                                return NodeFilter.FILTER_REJECT;
                            }
                        }
                        return NodeFilter.FILTER_ACCEPT;
                    }
                },
                false
            );

            let lastTextNode = null;

            while (walker.nextNode()) {
                const node = walker.currentNode;
                if (node.textContent.trim()) {
                    lastTextNode = node;
                }
            }

            if (!lastTextNode) return;

            const text = lastTextNode.textContent;
            const lastChar = text.slice(-1);

            if (!TARGET_CHARS.includes(lastChar)) return;

            lastTextNode.textContent = text.slice(0, -1);

            const span = document.createElement('span');
            span.className = 'text-yellow';
            span.textContent = lastChar;

            lastTextNode.parentNode.insertBefore(
                span,
                lastTextNode.nextSibling
            );
        });
    };

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', processHeadings);
    } else {
        processHeadings();
    }
})();

// Popups (data-popup trigger → .popup[data-popup-id])
(() => {
    document.addEventListener('click', (e) => {
        // Відкриття: клік по елементу з data-popup="some-popup".
        const trigger = e.target.closest('[data-popup]');
        if (trigger) {
            const id = trigger.getAttribute('data-popup');
            const popup = document.querySelector(`.popup[data-popup-id="${id}"]`);
            if (popup) {
                e.preventDefault();
                popup.classList.add('active');
                return;
            }
        }

        // Закриття по кнопці .popup-close всередині попапа.
        const closeBtn = e.target.closest('.popup-close');
        if (closeBtn) {
            const popup = closeBtn.closest('.popup');
            if (popup) popup.classList.remove('active');
            return;
        }

        // Закриття по кліку на сам попап (бекдроп), але не по його дочірніх елементах.
        const popup = e.target.closest('.popup');
        if (popup && e.target === popup) {
            popup.classList.remove('active');
        }
    });
})();

// Menu Dropdown Toggle (.menu > .menu-item-has-children)
(() => {
    const parents = document.querySelectorAll('.menu > .menu-item-has-children');
    if (!parents.length) return;

    parents.forEach((parent) => {
        parent.addEventListener('click', (e) => {
            // Клік по дочірніх елементах підменю не має перемикати (щоб меню не закривалось).
            if (e.target.closest('.sub-menu')) return;

            // Лінк верхнього рівня з реальним href веде на сторінку — перехід не блокуємо.
            const link = e.target.closest('a');
            const href = link ? link.getAttribute('href') : null;
            if (href && href !== '#') return;

            // Клік по пункту без реального лінка (href="#" чи іконка) — тоглимо.
            e.preventDefault();
            parent.classList.toggle('active');
        });
    });
})();